import backendApi from '@/api/backendApi';

const state = {
    status: {
        loading: false
    },
    user: null
};

const actions = {

    getUserData({
        dispatch,
        commit,
        rootState
    }) {

        const token = rootState.auth.token;

        if (!token) {
            return false;
        }

        commit('loading');

        backendApi.requestApi('GET', 'user')
            .then(
                user => {
                    commit('setUser', user);
                    commit('stopLoading');
                },
                error => {
                    dispatch('alert/error', error, {
                        root: true
                    });
                    commit('stopLoading');
                }
            );
    },

};

const getters = {
    getUserPermissions: state => {
        return state.user ? state.user.data.permissions : null;
    },
    getUserData: state => {
        return state.user ? state.user.data : null;
    },
    getUserRoles: state => {
        return state.user ? state.user.data.roles : null;
    }
}

const mutations = {
    loading(state) {
        state.status = {
            loading: true
        };
    },
    stopLoading(state) {
        state.status = {
            loading: false
        };
    },
    setUser(state, user) {
        state.user = user;
    }
};

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};